export const ADMIN_EMAILS = [
  "vgsoham@gmail.com",
  // "ananthveluvali@gmail.com",
  // "atmanjahagir@gmail.com",
  // "batmanjahagir@gmail.com",
  "k.gardner@crimsoneducation.org",
  "k.sliunkova@crimsoneducation.org",
  "krissrobert12@gmail.com",
  // "team@crimsoneducation.org",
  "j.beaton@crimsoneducation.org",
  "g.gladstein@crimsoneducation.org",
  // "nensytsyan@gmail.com",
  // "kriss@tenxbase.com",
  "senseyika@gmail.com",
  "admityogi@gmail.com",
  "ms.todosychuk@gmail.com",
  "s.nandan@crimsoneducation.org",
];

export function isAdminClientside(user) {
  return ADMIN_EMAILS.includes(user.email);
}

export function isAdminServerside(user) {
  return ADMIN_EMAILS.includes(user.email); /* && user?.emailVerified*/
}
